import React, { useState, useEffect } from 'react';
import { FaGasPump, FaTachometerAlt, FaCar } from 'react-icons/fa';
import { TbSteeringWheel } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import Skeleton from '../ui/Skeleton';

function RelatedCars() {
    const [listing, setListing] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchListing = async () => {
            try {
                const response = await fetch('/api/listing');
                let data = await response.json();
                data = data.filter(item => item.visibility === 'Active');
                data.sort((a, b) => new Date(b.date) - new Date(a.date));
                setListing(data.slice(0, 4));
            } catch (error) {
                // Error handled silently
            } finally {
                setLoading(false);
            }
        };
        fetchListing();
    }, []);

    const renderSkeleton = () => (
        <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
            <div className="flex">
                <Skeleton className="w-32 h-32 flex-shrink-0" />
                <div className="flex-1 p-4 space-y-2">
                    <Skeleton className="h-5 w-3/4" />
                    <Skeleton className="h-6 w-1/2" />
                    <Skeleton className="h-4 w-full mt-2" />
                </div>
            </div>
        </div>
    );

    if (loading) {
        return (
            <div className="space-y-4">
                {Array.from({ length: 4 }).map((_, index) => (
                    <React.Fragment key={index}>
                        {renderSkeleton()}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {listing.map((item) => (
                <Link
                    key={item._id}
                    to={`/cars/${item._id}`}
                    className="block group"
                >
                    <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-xl hover:border-red-200 transition-all duration-300">
                        <div className="flex">
                            <div className="w-32 h-32 flex-shrink-0 relative overflow-hidden bg-gray-100">
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                />
                            </div>
                            
                            <div className="flex-1 flex flex-col justify-between p-4 min-w-0">
                                <div className="mb-3">
                                    <h3 className="text-base font-bold text-gray-900 mb-1 line-clamp-1 group-hover:text-[#DC2626] transition-colors">
                                        {item.title}
                                    </h3>
                                    <p className="text-xl font-extrabold text-[#DC2626]">
                                        ${item.price}
                                    </p>
                                </div>

                                <div className="space-y-2">
                                    <div className="grid grid-cols-2 gap-2">
                                        <div className="flex items-center gap-1.5 min-w-0">
                                            <FaGasPump className="text-[#DC2626] text-xs flex-shrink-0" />
                                            <span className="text-xs text-gray-600 truncate">{item.fuelType || 'N/A'}</span>
                                        </div>
                                        <div className="flex items-center gap-1.5 min-w-0">
                                            <FaCar className="text-[#DC2626] text-xs flex-shrink-0" />
                                            <span className="text-xs text-gray-600 truncate">{item.bodyType || 'N/A'}</span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-2 gap-2">
                                        <div className="flex items-center gap-1.5 min-w-0">
                                            <FaTachometerAlt className="text-[#DC2626] text-xs flex-shrink-0" />
                                            <span className="text-xs text-gray-600 truncate">
                                                {item.mileage ? `${item.mileage} ${item.mileageUnit || 'mi'}` : 'N/A'}
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-1.5 min-w-0">
                                            <TbSteeringWheel className="text-[#DC2626] text-xs flex-shrink-0" />
                                            <span className="text-xs text-gray-600 truncate">{item.vehicleTransmission || 'N/A'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
}

export default RelatedCars;

